import React, {useEffect, useState} from 'react';
import { Autocomplete } from '@mantine/core';
import {useField} from "formik";

function MantineAutoCompleteField(props) {
    const {name, data} = props;
    const [field, meta, helpers] = useField(name);
    const [value, setValue] = useState(data.filter(el => el.value === field.value)[0]?.label || "");
    const {setValue: setFieldValue, setTouched} = helpers;

    const handleChange = (v) => {
        const found = data.find(d => d.value === v);

        if (found !== undefined) {
            setValue(found.label)
        } else {
            setValue(v)
        }
        setTouched(name, true)
        setFieldValue(v)
    }

    useEffect(() => {
        const found = data.find(el => el.value === field.value);
        if (found)
            setValue(found.label)
    }, []);

    return (
        <Autocomplete
            filter={(v, item) =>
                item.value.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(v.toLowerCase().trim()) ||
                item.label.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(v.toLowerCase().trim())
            }
            {...props}
            limit={20}
            value={value}
            maxDropdownHeight={200}
            nothingFound="Sin resultados"
            onChange={handleChange}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
        />
    );
}

export default MantineAutoCompleteField;